export default __webpack_public_path__ + "static/media/logo.bd72d1af.jpeg";